"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const error_module_css_1 = __importDefault(require("./error.module.css"));
const react_intl_1 = require("react-intl");
const web_sds_c_1 = require("@snapchat/web-sds-c");
const web_env_1 = require("@snapchat/web-env");
const web_i18n_1 = require("@snapchat/web-i18n");
const i18n_1 = require("../../i18n");
/**
 *
 */
function ErrorScreen({ onClick, locale, messages, }) {
    const onButtonClick = () => {
        onClick?.();
        (0, web_env_1.getWindow)()?.location.reload();
    };
    // https://static.snapchat.com/images/coffee-spill.svg
    // https://static.snapchat.com/images/spill-coffee.svg
    const { locale: resolvedLocale, messages: resolvedMessages } = (0, web_i18n_1.useLocale)({
        defaultLocale: locale,
        defaultMessages: messages,
        loadMessages: i18n_1.loadMessages,
    });
    const intl = (0, react_intl_1.useIntl)();
    const imgAlt = intl.formatMessage({
        id: "ud7shj",
        defaultMessage: "Spilled coffee error image",
        description: "Error boundary image alt text",
    });
    return ((0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, { locale: resolvedLocale, defaultLocale: web_i18n_1.DEFAULT_LOCALE, messages: resolvedMessages, children: (0, jsx_runtime_1.jsxs)("div", { className: error_module_css_1.default.container, children: [(0, jsx_runtime_1.jsx)("img", { src: "https://static.snapchat.com/images/coffee-spill.svg", width: 200, height: 200, alt: imgAlt }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "udmFsG", defaultMessage: "An error occurred. Please reload the page.", description: "error message" }), (0, jsx_runtime_1.jsx)(web_sds_c_1.ButtonOrLink, { dataTest: "reload", className: error_module_css_1.default.btn, onClick: onButtonClick, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "A+17s3", defaultMessage: "Reload page", description: "reload button text" }) })] }) }));
}
exports.default = ErrorScreen;
//# sourceMappingURL=index.js.map